import { render } from "./BlogHome.vue?vue&type=template&id=6c2d9a9e"
import script from "./BlogHome.vue?vue&type=script&lang=js"
export * from "./BlogHome.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__